var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 11,
    viewBox: "0 0 68 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28895 0L6.4764 3.46798H10.319L7.21028 5.61131L8.39772 9.07928L5.28895 6.93596L2.18018 9.07928L3.36763 5.61131L0.25886 3.46798H4.10151L5.28895 0Z",
    fill: "#DEA56E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6444 0L20.8319 3.46798H24.6745L21.5657 5.61131L22.7532 9.07928L19.6444 6.93596L16.5357 9.07928L17.7231 5.61131L14.6143 3.46798H18.457L19.6444 0Z",
    fill: "#DEA56E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9999 0L35.1873 3.46798H39.03L35.9212 5.61131L37.1087 9.07928L33.9999 6.93596L30.8911 9.07928L32.0786 5.61131L28.9698 3.46798H32.8124L33.9999 0Z",
    fill: "#DEA56E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3554 0L49.5428 3.46798H53.3855L50.2767 5.61131L51.4641 9.07928L48.3554 6.93596L45.2466 9.07928L46.434 5.61131L43.3253 3.46798H47.1679L48.3554 0Z",
    fill: "#DEA56E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7108 0L63.8983 3.46798H67.7409L64.6322 5.61131L65.8196 9.07928L62.7108 6.93596L59.6021 9.07928L60.7895 5.61131L57.6807 3.46798H61.5234L62.7108 0Z",
    fill: "#DEA56E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.5187d6017e13b77a2896ffda9dcd8870.svg";
export { ForwardRef as ReactComponent };